//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['error'],
  components: {},
  data() {
    return {}
  },
  created() {
    console.log('Error object', this.error);
    console.log('Error isApiError', this.error.isApiError);
    if (this.error.isApiError) {
      console.log('Error apiStatusCode', this.error.apiStatusCode);
      console.log('Error apiErrorMessage', this.error.apiErrorMessage);
    } else {
      console.log('Error statusCode', this.error.statusCode);
      console.log('Error message', this.error.message);
    }

    if (this.error.statusCode === 404) {
      // this.$router.push(this.localePath('/404'))
    }
    if (this.error.statusCode === 403) {
      // this.$router.push(this.localePath('/403'))
    }
    if (this.error.statusCode === 503) {
      // this.$router.push(this.localePath('/maintenance'))
    }
  }
}
